module.exports = {
  url: '//stampsy-eu-1.s3.amazonaws.com/uploads/11/04/2014/user/5/eee9813e-7403-4ee6-b317-1f60e3103e43.png',
  colors: {
    top: '999999',
    bottom: '999999'
  },
  size: {
    width: 1200,
    height: 1200
  }
};


/** WEBPACK FOOTER **
 ** ./constants/DefaultAudioImage.js
 **/